var map = {
	"./computer_new_at_de-AT": 97159,
	"./computer_new_at_de-AT.webp": 97159,
	"./computer_new_be_fr-BE": 48626,
	"./computer_new_be_fr-BE.webp": 48626,
	"./computer_new_be_nl-BE": 35119,
	"./computer_new_be_nl-BE.webp": 35119,
	"./computer_new_ch_de-CH": 40846,
	"./computer_new_ch_de-CH.webp": 40846,
	"./computer_new_ch_fr-CH": 72910,
	"./computer_new_ch_fr-CH.webp": 72910,
	"./computer_new_de_de": 26409,
	"./computer_new_de_de.webp": 26409,
	"./computer_new_dk_da": 65512,
	"./computer_new_dk_da.webp": 65512,
	"./computer_new_es_es": 88528,
	"./computer_new_es_es.webp": 88528,
	"./computer_new_fi_fi": 34335,
	"./computer_new_fi_fi.webp": 34335,
	"./computer_new_fr_fr": 99160,
	"./computer_new_fr_fr.webp": 99160,
	"./computer_new_gb_en": 80631,
	"./computer_new_gb_en.webp": 80631,
	"./computer_new_global_en": 7379,
	"./computer_new_global_en.webp": 7379,
	"./computer_new_global_tr": 34026,
	"./computer_new_global_tr.webp": 34026,
	"./computer_new_hk_en-HK": 84274,
	"./computer_new_hk_en-HK.webp": 84274,
	"./computer_new_in_en-IN": 61458,
	"./computer_new_in_en-IN.webp": 61458,
	"./computer_new_it_it": 93511,
	"./computer_new_it_it.webp": 93511,
	"./computer_new_lu_fr-LU": 75830,
	"./computer_new_lu_fr-LU.webp": 75830,
	"./computer_new_nl_nl": 35446,
	"./computer_new_nl_nl.webp": 35446,
	"./computer_new_no_nb": 61084,
	"./computer_new_no_nb.webp": 61084,
	"./computer_new_pl_pl": 46041,
	"./computer_new_pl_pl.webp": 46041,
	"./computer_new_se_sv": 18983,
	"./computer_new_se_sv.webp": 18983,
	"./computer_new_sg_en-SG": 56588,
	"./computer_new_sg_en-SG.webp": 56588,
	"./computer_new_ua_ru-UA": 42390,
	"./computer_new_ua_ru-UA.webp": 42390,
	"./computer_new_ua_uk": 17742,
	"./computer_new_ua_uk.webp": 17742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31993;